export default{
  choicelang: null,
  contents: [{
    lang: 'EN',
    id: 0,
    mynav: {
      contactus: 'Contact Us',
      login: 'LOGIN'
    },
    banner: {
      title: 'Maximize Your Ad Revenue',
      dec: 'The Leading Data-driven Monetization Platform for Mobile Apps'
    },
    two: {
      title_a: 'Intelligent Technology',
      title_b: 'Premium Demand',
      title_c: 'Customized Services',
      dec_a: 'Deliver highly-targeted ads that match the interests of your user base with our predictive and precise audience matching algorithms.',
      dec_b: 'Ensure the highest fill rates and eCPMs for your inventory with our global high-quality advertiser network.',
      dec_c: 'A dedicated team of mobile experts committed to providing strategic guidance and 24/7 support to help your business grow.'
    },
    video: {
      title_a: 'INCREASE AD REVENUE',
      dec_a: 'Rewarded Video ads drive better results. A high-engagement ad format means better conversion and greater eCPMs.',
      title_b: 'IMPROVE USER EXPERIENCE',
      dec_b: 'Rewarded video ads give users a benefit in exchange for an engagement with an opt-in ad. Users can opt out of the ad at any time.',
      title_c: 'BOOST USER RETENTION',
      dec_c: 'Rewarded video ads encourage users to stay longer in the app. Users are incentivized to watch a video ad in exchange for a virtual reward, such as in-app currency, points and lives.'
    },
    adtype: {
      title_a: 'Native',
      dec_a: 'Customize ads that match the look and feel of your app feel seamlessly.',
      title_b: 'App wall',
      dec_b: 'A selection of sponsored apps that allow users to discover and install apps relevant to their interests.',
      title_c: 'Banner',
      dec_c: 'The most universal ad format that is simple to integrate and good for awareness.',
      title_d: 'Interstitial',
      dec_d: 'Rich interactive ads that are best placed when there is a natural break in your app flow. '
    },
    footer: {
      copy: 'Copyright © 2018 Yeahmobi.com | All Rights Reserved',
      emall_title: 'Email:',
      phone_title: 'Phone Number:',
      qq_title: 'QQ:',
      skype_title: 'Skype:',
      address_title: 'Address:',
      address: {
        a: 'A 1101,Zhongguancun SoHo,',
        b: 'Haidian District',
        c: 'Beijing',
        d: 'China'
      }
    }
  },
  {
    lang: 'CH',
    id: 1,
    mynav: {
      contactus: '联系我们',
      login: '登录'
    },
    banner: {
      title: '最大限度地为您的APP变现',
      dec: '领先的数据驱动移动广告聚合平台'
    },
    two: {
      title_a: '高效算法',
      title_b: '高填充率及高eCPM',
      title_c: '24/7 服务',
      dec_a: '智能算法保障广告精准投放，确保充分利用产品用户价值',
      dec_b: '全球优质广告资源及渠道确保高填充及高eCPM',
      dec_c: '全天候服务，随时在线解决您的疑问'
    },
    video: {
      title_a: '有效增加广告收入',
      dec_a: '基于目前数据表现，激励视频广告比一般静态展示广告的收入更高，平均eCPM至少是其他广告形式的2倍。',
      title_b: '提升用户体验',
      dec_b: '用户可以选择跳过不观看激励视频广告，或选择观看完广告后获得奖励，这种广告形式更容易被用户接受。相对于其他广告形式，用户拥有了主动选择权，无需被动接受。',
      title_c: '提高用户留存率',
      dec_c: '通过观看激励视频广告，用户可以得到复活、试用高级功能、获得金币等奖励，使得他们在APP内停留更长时间，一定程度上有利于提升用户留存率。'
    },
    adtype: {
      title_a: '原生广告',
      dec_a: '开发者可以根据自身产品特点来设计广告展示形式，确保良好的用户体验',
      title_b: '应用墙广告',
      dec_b: '应用墙以单独界面推荐30余款用户可能感兴趣的广告，通过引导按钮点击进入，不影响用户正常使用APP',
      title_c: '条幅广告',
      dec_c: '作为一种被长期广泛使用的广告形式，用户对条幅广告习以为常、比较容易接受',
      title_d: '插屏广告',
      dec_d: '通过人性化的广告样式自主设计，可以在确保用户使用体验的同时实现有效变现'
    },
    footer: {
      copy: 'Copyright © 2018 Yeahmobi.com | All Rights Reserved',
      emall_title: '邮箱:',
      phone_title: '电话:',
      qq_title: 'QQ:',
      skype_title: 'Skype:',
      address_title: '地址:',
      address: {
        a: '北京市',
        b: '海淀区',
        c: '中关村SOHO A区1101',
        d: '10080'
      }
    }
  }]
}



// WEBPACK FOOTER //
// ./src/store/modules/state.js